module.exports = __webpack_public_path__ + "img/9791185072005.87adb0a0.jpg";